import * as React from "react";

function Filter(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 21 20" fill="none" {...props}>
      <path
        d="M5.5 10h10M3 5h15M8 15h5"
  stroke="var(--color-blue-500)"
        strokeWidth={1.667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Filter;
